module.exports = __webpack_public_path__ + "img/discount-offer.c4ac1de2.webp";